
/*
  Announcement bar
*/
const initStickyAnnouncementBar = () => {
  const section = document.querySelector('.announcement-bar-sticky')
  if (!section) return

  section.closest('.shopify-section').classList.add('sticky-top')

  const navbar = document.querySelector('[id*="__navbar"].sticky-top')
  if (!navbar) return

  navbar.style.top = document.querySelector('.announcement-bar-sticky').clientHeight + 'px'
}
initStickyAnnouncementBar()

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('.announcement-bar-sticky')) {
    initStickyAnnouncementBar()
  }
})

document.addEventListener('shopify:block:select', (event) => {
  const carousel = event.target.closest('.announcement-bar .carousel')

  if (carousel) {
    bootstrap.Carousel.getOrCreateInstance(carousel, { ride: false })
      .to(event.target.dataset.index)
  }
})